import Icon from '@ant-design/icons';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import { ReactComponent as TrashIconSvg } from '../../assets/trash-icon.svg';

export const TrashIcon = (props: Partial<CustomIconComponentProps>) => {
  return <Icon component={TrashIconSvg} {...props} />;
};
